import React, {useState} from 'react';
import api from "../../services/api";
import {
    Badge,
    NavLink
} from '@mantine/core';
import {
    IconHome,
    IconUser,
    IconChartDots,
    IconChartInfographic
} from '@tabler/icons-react';

const NavBar = (props) => {
    const {authUser} = props
    const permissions = (localStorage.getItem('permissions') || "")
        .split(',')
        .filter(key => key.trim() !== "") // Ignore les éléments vides
        .reduce((acc, key) => {
            acc[key.trim()] = true;
            return acc;
        }, {});
    const navLinksData = [
        {
            href: "/",
            label: "Accueil",
            icon: <IconHome size="2rem" stroke={2}/>
        },

        // ajouter les liens pour de pages connecter
        {
            href: "/profile",
            label: "Profil",
            icon: <IconUser size="2rem" stroke={2}/>,
            auth_user: true,
            permissions: ['profil']
        },
        {
            href: "/report-list-appel",
            label: "Statistique d'appel",
            icon: <IconChartDots size="2rem" stroke={2}/>,
            auth_user: true,
            permissions: ['stats']
        },
        {
            href: "/report-list",
            label: "Rapport d'Activité",
            icon: <IconChartInfographic size="2rem" stroke={2}/>,
            auth_user: true,
            permissions: ['rapport-activite']
        },

        // liens de test
        {
            href: "#required-for-focus",
            label: "With description",
            description: "Additional information",
            icon: (
                <Badge size="xs" color="red" circle>
                    3
                </Badge>
            ),
        },
    ];

    const _hasNavLink = (link) => {
        let navLink = false
        if (!link.auth_user) navLink = true
        if (link.auth_user && authUser) navLink = true


        if (link.permissions) {
            console.log('label', link.label)
            console.log('permissions', permissions)
            link.permissions.forEach(permission => {
                console.log("Permission:", permission);
                if (!permissions[permission]) navLink = false
            });
        }
        return navLink
    };
    const hasNavLink = (link) => {
    // Vérifie si l'utilisateur est authentifié si nécessaire, sinon continue
    if (link.auth_user && !authUser) return false;

    // Vérifie les permissions requises, s'il y en a, et s'assure que toutes sont présentes
    return !link.permissions || link.permissions.every(permission => permissions[permission]);
};

    return (
        <>
            {navLinksData.map((link, index) => (
                // (!link.auth_user || (link.auth_user && authUser)) &&
                hasNavLink(link) && (
                    <NavLink
                        key={index}
                        href={link.href}
                        label={link.label}
                        leftSection={link.icon}
                        description={link.description}
                        onClick={link.onClick}
                    />
                )
            ))}
        </>

    );
};

export default NavBar;